import { render, staticRenderFns } from "./EcCard.vue?vue&type=template&id=284106ac&scoped=true"
import script from "./EcCard.vue?vue&type=script&lang=js"
export * from "./EcCard.vue?vue&type=script&lang=js"
import style0 from "./EcCard.vue?vue&type=style&index=0&id=284106ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284106ac",
  null
  
)

export default component.exports